import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ViewTransactionsGrid from './ViewTransactionsGrid';
import {
  fetchInvoices,
  changeInvoicesLinesStatus,
  fetchInvoicesLines,
  deleteInvoices,
  exportTransactions,
  fetchInvoiceById,
  changeInvoicesStatus,
  deleteAllInvoices,
  changeAllInvoicesStatus,
  exportAllTransactions
} from 'redux/invoices/InvoicesActions';
import { calculateInvoicesTaxes, calculateTaxesForAllInvoices } from 'redux/taxCalculation/TaxCalculationActions';

const mapStateToProps = ({ invoices, invoiceFilters }) => ({
  invoices: invoices.invoices,
  pageState: invoices.pageState,
  fetchingInvoices: invoices.fetchingInvoices,
  appliedFilters: invoiceFilters.appliedFilters,
  appliedFiltersFlag: invoiceFilters.appliedFiltersFlag
});

const mapDispatchToProps = dispatch => ({
  invoicesActions: bindActionCreators({
    changeInvoicesLinesStatus,
    fetchInvoices,
    fetchInvoicesLines,
    deleteInvoices,
    exportTransactions,
    fetchInvoiceById,
    changeInvoicesStatus,
    deleteAllInvoices,
    changeAllInvoicesStatus,
    exportAllTransactions
  }, dispatch),
  taxCalculationActions: bindActionCreators( {calculateInvoicesTaxes, calculateTaxesForAllInvoices}, dispatch )
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewTransactionsGrid);



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/ViewTransactionsGridConnector.js